<script>
export default {
  functional: true,

  props: {
    isVirtual: { type: Boolean, default: false }
  },

  render(h, { props }) {
    return props.isVirtual
      ? [<v-icon icon="airplay" />, <span>Livestream event</span>]
      : [<v-icon icon="place" />, <span>Event</span>]
  }
}
</script>
